import { createContext, useContext, useState, useEffect } from 'react';

// Define the context
const DeferredPromptContext = createContext<any>(null);

// Create a custom hook for easier access to the context
export const useDeferredPrompt = () => useContext(DeferredPromptContext);

// Create a provider component
export const DeferredPromptProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

	useEffect(() => {
		const promptEvent = (event: any) => {
			console.log('beforeinstallprompt fired');
			event.preventDefault(); // Prevent the default prompt
			setDeferredPrompt(event); // Save the event for later use
		};

		window.addEventListener('beforeinstallprompt', promptEvent);

		return () => {
			window.removeEventListener('beforeinstallprompt', promptEvent);
		};
	}, []);

	return <DeferredPromptContext.Provider value={deferredPrompt}>{children}</DeferredPromptContext.Provider>;
};
